// eslint-disable-next-line import/prefer-default-export
export const SET_ITEM_TO_SPY = 'SET_ITEM_TO_SPY';
export const SET_ITEMS_TO_SPY = 'SET_ITEMS_TO_SPY';
export const SET_ACTIVE_ITEM = 'SET_ACTIVE_ITEM';
export const SET_ACTIVE_ITEM_FROM_SCROLL = 'SET_ACTIVE_ITEM_FROM_SCROLL';
export const SET_LAST_ACTIVE_ITEM = 'SET_LAST_ACTIVE_ITEM';
